import { C as e, T as t, i as n, n as r, r as i, t as a, w as o } from "./sdk.gen-CV5NlfXb.js";
//#region src/utils/querySerializer.ts
var s = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, c = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, l = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, u = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(c(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let a = s(r), o = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : p(n, t, { allowReserved: e })).join(a);
	return r === "label" || r === "matrix" ? a + o : o;
}, d = ({ allowReserved: e, name: t, value: n }) => n == null ? "" : `${t}=${e ? n : encodeURIComponent(n)}`, f = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = l(r), s = Object.entries(i).map(([t, i]) => p(r === "deepObject" ? `${n}[${t}]` : t, i, { allowReserved: e })).join(o);
	return r === "label" || r === "matrix" ? o + s : s;
}, p = (e, t, { allowReserved: n, array: r, object: i } = {}) => t == null ? "" : Array.isArray(t) ? u({
	allowReserved: n,
	explode: !0,
	name: e,
	style: "form",
	value: t,
	...r
}) : typeof t == "object" ? f({
	allowReserved: n,
	explode: !0,
	name: e,
	style: "deepObject",
	value: t,
	...i
}) : d({
	allowReserved: n,
	name: e,
	value: t
}), m = ({ allowReserved: e, array: t, object: n } = {}) => (r) => {
	let i = [];
	if (r && typeof r == "object") for (let a in r) {
		let o = r[a], s = p(a, o, {
			allowReserved: e,
			array: t,
			object: n
		});
		s && i.push(s);
	}
	return i.join("&");
}, h = (e) => !e?.dimensions?.weight || e.dimensions.weight.unit !== "gr" ? e : {
	...e,
	dimensions: {
		...e.dimensions,
		weight: {
			...e.dimensions.weight,
			unit: "g"
		}
	}
};
e.getConfig().baseUrl || e.setConfig({ baseUrl: t });
var g = () => e.getConfig().auth, _ = (n = { token: void 0 }) => {
	if (!n.token) throw Error("Token is required");
	let r = {
		baseUrl: t,
		auth: n.token,
		querySerializer: m()
	};
	return n.environment && n.environment === "acceptance" && (r.baseUrl = o), n.locale && (r.headers = {
		...r.headers,
		"Accept-Language": n.locale
	}), e.setConfig(r), n.token;
}, v = (t) => {
	e.setConfig({ headers: {
		...e.getConfig().headers,
		"Accept-Language": t
	} });
}, y = async (e) => {
	let t = await a({ query: e });
	return t.data?.results && (t.data.results = t.data.results.map((e) => h(e))), t.data;
}, b = async (e) => h((await r({ body: e })).data), x = async (e) => h((await n({ body: e })).data), S = async (e) => {
	await i({ body: e });
}, C = () => ({
	getProducts: y,
	getToken: g,
	initClient: _,
	postCreateProduct: b,
	postManageInventory: S,
	postUpdateProduct: x,
	setAcceptLanguageHeader: v
});
//#endregion
export { C as t };
